;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import {
  RESTRICTION_MODAL_VARIANTS,
  USER_RESTRICTION_TYPES,
  type RestrictionModalVariant,
  type UserRestriction,
} from '@/types/restriction';

/**
 * Maps a restriction value to the modal variant to show.
 * Returns NONE for not_restricted/watchlist/null/undefined so the UI fails open.
 */
export function getRestrictionModalVariant(
  restriction?: UserRestriction | null
): RestrictionModalVariant {
  if (!restriction) return RESTRICTION_MODAL_VARIANTS.NONE;

  switch (restriction.type) {
    case USER_RESTRICTION_TYPES.AML:
      return RESTRICTION_MODAL_VARIANTS.SUSPENSION;
    case USER_RESTRICTION_TYPES.BLOCK:
    case USER_RESTRICTION_TYPES.FINAL:
      return RESTRICTION_MODAL_VARIANTS.FINAL_REJECTION;
    case USER_RESTRICTION_TYPES.FIRST_REJECTION:
      return RESTRICTION_MODAL_VARIANTS.FIRST_REJECTION;
    default:
      return RESTRICTION_MODAL_VARIANTS.NONE;
  }
}
